import type { TutorAvailability } from '@brighterly/lib-core-types/discipline/types'

import { useDisciplineStore } from '@stores/discipline'
import { useScheduleStore } from '@stores/schedule'

import { useCsRoutes } from '@composables/routes/cs-route.hook'
import { useToast } from '@hooks/toast/index.hook'

import { useNuxtApp } from '#app'

export const useTutorAvailability = async (): Promise<TutorAvailability | null> => {
  const { $axios } = useNuxtApp()

  const disciplineStore = useDisciplineStore()
  const scheduleStore = useScheduleStore()
  const toast = useToast()

  const id = disciplineStore.activeDiscipline?.id || null

  const setError = (message: string): void => {
    scheduleStore.setAvailability(null)
    console.error(message)
    toast.error({
      title: 'Unexpected error',
      description: message,
    })
  }

  if (!id) {
    setError('Invalid discipline ID.')
    return null
  }

  const url = useCsRoutes('schedule.tutor-availability', {
    '[discipline_id]': id,
  })

  if (!url) {
    setError('Invalid request URL.')
    return null
  }

  scheduleStore.setLoading(true)
  try {
    const { data } = await $axios.get(url)

    const availability = data?.availability || null
    scheduleStore.setAvailability(availability)

    return availability
  } catch (err: any) {
    console.error(err)
    return null
  } finally {
    scheduleStore.setLoading(false)
  }
}
